import { Observable, FetchResult } from 'apollo-link'
import { ServerError, ServerParseError } from 'apollo-link-http-common'
import store from '../../store'
import { onError } from 'apollo-link-error'
import { logErrorMessages } from '@vue/apollo-util'
import router from '@/router'
import i18n from '@/config/i18n'
import { showInfo } from '@/packages/toast'

/**
 * ネットワークエラーハンドラー
 */
const onNetworkError = (
  error: Error | ServerError | ServerParseError
): Observable<FetchResult> | void => {
  if (!('statusCode' in error)) {
    return
  }

  if (error.statusCode === 401) {
    // unauthenticated / redirect
    store.dispatch('auth/logout')
    router.push({ name: 'Login' })
    return
  }

  if (error.statusCode === 419) {
    // token expires / redirect
    showInfo(i18n.tc('errors.sessionTimeout'))
    store.dispatch('auth/logout')
    router.push({ name: 'Login' })
  }
}

const errorLink = onError((error) => {
  if (process.env.NODE_ENV !== 'production') {
    logErrorMessages(error)
  }
  store.dispatch('loading/hideLoading')
  const { networkError } = error
  if (networkError) {
    return onNetworkError(networkError)
  }
})

export default errorLink
